import React from 'react';
import Message from './message';
import ReplyChatSwitcher from './replyChatSwitcher';
interface ChatmsgItemProps {
  chat: ISampleCHatlist;
}
const ChatmsgItem = ({chat}: ChatmsgItemProps) => {
  return (
    <>
      {chat.post_reply_type && (
        <ReplyChatSwitcher post_reply_type={chat.post_reply_type} chat={chat} />
      )}
      <Message
        created_at={chat.created_at}
        is_author={chat.is_author}
        text={chat.text}
        is_seen={chat.is_seen}
      />
    </>
  );
};

export default ChatmsgItem;
